import { render, staticRenderFns } from "./plan-design.vue?vue&type=template&id=571d3b26&scoped=true"
import script from "./plan-design.vue?vue&type=script&lang=js"
export * from "./plan-design.vue?vue&type=script&lang=js"
import style0 from "./plan-design.vue?vue&type=style&index=0&id=571d3b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d3b26",
  null
  
)

export default component.exports